// eslint-disable-next-line import/prefer-default-export
export const ENV_TYPES = {
  TEST: 'TEST',
  PRODUCTION: 'PRODUCTION',
};

export const LOG_LEVEL = {
  INFO: { name: 'INFO', value: 1 },
  WARN: { name: 'WARN', value: 2 },
  ERROR: { name: 'ERROR', value: 3 },
};

export const API_RESOURCE_URLS = {
  LOG_ERROR: 'logs',
  AUTH_ALLOWED_RESOURCE: 'authorization/allowed-resources',
};
export const APPLICATION_NAME = 'EP Performance Insights';

export const PERFORMANCE_INSIGHTS_APP_NAME = 'PERFORMANCE INSIGHTS';

export const EP_APP_RESOURCES = {
  'org:tml:application:performance-insights': PERFORMANCE_INSIGHTS_APP_NAME,
};

export const DATE_FORMAT = {
  ISO: 'YYYY-MM-DD',
  ISO_DATE_FNS: 'yyyy-MM-dd',
  DAY_MONTH_YEAR: 'DD-MM-YYYY',
};

export const PERSONAS = {
  BUYER: 'BUYER',
  VENDOR: 'VENDOR',
  FBV_VENDOR: 'VENDOR_WITH_FBV',
  FBV: 'FBV',
};

export const TOOLS = {
  MASTER_DATA_MANAGEMENT: 'Supply Chain Master Data',
  ASN_OVERVIEW: 'Asn Overview',
};

export const SORT_STATE = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  UNSORTED: 'unsorted',
};

export const PUNE_PLANT_VALUE = '1001';

export const MESSAGE_TYPE = {
  SUCCESS: 'Success',
  FAILURE: 'Fail',
  INFORMATION: 'Information',
  WAR: 'Information',
  INTERNAL_ERROR: 'Internal Error',
  LOADING: 'Loading',
};

export const VENDOR_OPERATIONS = {
  DROP_MATERIAL: 'drop-material',
  DISPATCH_MATERIAL: 'dispatch-material',
};

export const BUYER_OPERATIONS = {
  DISPATCH_MATERIAL: 'dispatch-material',
};

export const ASN_STATUS = {
  READY_FOR_DROP: 'READY_FOR_DROP',
  LINE_OUT: 'LINE_OUT',
  PLANNED: 'PLANNED',
  LINE_ON: 'LINE_ON',
  DROPPED: 'DROPPED',
  ROLLED: 'ROLLED',
  WTCL: 'WTCL',
  SFLT: 'SFLT',
};

export const ASN_STATUS_SORT_ORDER = {
  [ASN_STATUS.DROPPED]: 0,
  [ASN_STATUS.ROLLED]: 1,
  [ASN_STATUS.WTCL]: 2,
};

export const API_TOKEN = {
  API_DATA_TOKEN: '',
  API_PREFERRED_USERNAME:'',
  API_EMAIL: '',
  API_USER_NAME: ''
};

export const DISPLAY_MESSAGES = {
  NAVIGATION_WARNING:
    "All edits on this page have not been saved. Do you wish to continue?",
  PLAN_UPLOAD_SUCCESS: 'Plan uploaded.',
  PLAN_UPLOAD_FORBIDDEN:
    'User is not authorised to create/edit Plan, for other Plants.',
  PLAN_UPLOAD_ERROR:
    'Plan could not be uploaded. Clear following errors and try again.',
  FORCE_CLOSE_ERROR: 'Unable to force close. Please try again.',
  DOWNLOAD_ERROR: 'Unable to download. Please try again.'
};

export const RECON_STATUS = {
  INITIATED: "INITIATED",
  PENDING: "PENDING",
  IN_REVIEW: "IN_REVIEW",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
};